<button
  *ngIf="type === 'button'"
  class="button-basic {{buttonStyle}} {{size}}"
  [class.is-part-dropdown]="isPartDropdown"
  [class.circle]="isCircle"
  [class.stretch-horizontal]="stretchHorizontal"
  [class.is-loading]="isLoading"
  [class.disabled]="isDisabled"
  [class.is-bold]="isTextBold"
  [style.border-color]="displayBorderColor"
  [style.background-color]="displayBackgroundColor"
  [style.outline-color]="displayOutlineColor"
  [style.text-align]="textAlign"
  (click)="onClick($event)"
  [attr.data-test]="dataTest">
  <ng-container [ngTemplateOutlet]="ButtonContent">
  </ng-container>
</button>

<!-- TODO angular 13 upgrade will alow routerLink to take null value, disabeling it, and we will be able to 
use one button for both non-reload internal links and external links -->
<a
  *ngIf="type === 'anchor' && isExternalURL"
  [href]="navigationRoute"
  [target]="navigationTarget"
  rel="noopener noreferrer"
  class="button-basic {{buttonStyle}} {{size}}"
  [class.stretch-horizontal]="stretchHorizontal"
  [class.is-loading]="isLoading"
  [class.disabled]="isDisabled"
  [class.is-bold]="isTextBold"
  [style.border-color]="displayBorderColor"
  [style.background-color]="displayBackgroundColor"
  [style.outline-color]="displayOutlineColor"
  (click)='onClick($event)'
  [attr.data-test]="dataTest">
  <ng-container [ngTemplateOutlet]="ButtonContent">
  </ng-container>
</a>

<a
  *ngIf="type === 'anchor' && !isExternalURL"
  [routerLink]="navigationRoute"
  class="button-basic {{buttonStyle}} {{size}}"
  [class.stretch-horizontal]="stretchHorizontal"
  [class.is-loading]="isLoading"
  [class.disabled]="isDisabled"
  [class.is-bold]="isTextBold"
  [style.border-color]="displayBorderColor"
  [style.background-color]="displayBackgroundColor"
  [style.outline-color]="displayOutlineColor"
  (click)='onClick($event)'
  [attr.data-test]="dataTest">
  <ng-container [ngTemplateOutlet]="ButtonContent">
  </ng-container>
</a>

<ng-template #ButtonContent>
  <div
    class="icon-{{iconPosition}}"
    [class.align-icon]="icon">
    <svg-icon
      *ngIf="icon && !isLoading"
      [ngClass]="text ? iconPosition : ''"
      [src]="icon"
      alt="{{dataTest || 'icon'}}"
      [svgStyle]="{
        'color': displayIconColor,
        'width.px': iconSize,
        'height.px': iconSize,
        'viewBox':'0 0 {{iconSize}} {{iconSize}}'
      }"
      [attr.data-test]="'buttonIcon' + (iconPosition | titlecase)">
    </svg-icon>

    <div
      *ngIf="text"
      [style.color]="!isLoading ? displayTextColor : 'transparent'"
      class="button-text"
      data-test="buttonText">
      {{ text }}
    </div>
  </div>

  <span
    *ngIf="count !== null"
    class="button-count"
    data-test="buttonCount">
    {{ count }}
  </span>

  <svg-icon
    *ngIf="isDropdown"
    src="assets/icons/chevron-down-currentColor.svg"
    class="margin-quarter--left"
    [class.rotate-180]="showDropdown"
    [svgStyle]="{
      'width.px': size === 'small' ? 12 : 15,
      'height.px': size === 'small' ? 12 : 15,
      'color': displayIconColor
    }"
    data-test="buttonIconRightDropdown">
  </svg-icon>
</ng-template>
